/**
 * Maps flag state names to ISO 3166-1 alpha-2 country codes
 * Used for displaying flag icons with flag-icon-css library
 */
const flagStateToCountryCode: { [key: string]: string } = {
  'bahamas': 'bs',
  'panama': 'pa',
  'malta': 'mt',
  'liberia': 'lr',
  'marshall islands': 'mh',
  'cyprus': 'cy',
  'singapore': 'sg',
  'barbados': 'bb',
  'bermuda': 'bm',
  'cayman islands': 'ky',
  'netherlands': 'nl',
  'norway': 'no',
  'united kingdom': 'gb',
  'uk': 'gb',
  'united states': 'us',
  'usa': 'us',
  'italy': 'it',
  'greece': 'gr',
  'portugal': 'pt',
  'france': 'fr',
  'spain': 'es',
  'germany': 'de',
  'denmark': 'dk',
  'sweden': 'se',
  'finland': 'fi',
  'australia': 'au',
  'new zealand': 'nz',
  'japan': 'jp',
  'south korea': 'kr',
  'china': 'cn',
  'hong kong': 'hk',
  'philippines': 'ph',
  'indonesia': 'id',
  'thailand': 'th',
  'malaysia': 'my',
  'india': 'in',
  'brazil': 'br',
  'argentina': 'ar',
  'chile': 'cl',
  'mexico': 'mx',
  'canada': 'ca',
  'russia': 'ru',
  'turkey': 'tr',
  'egypt': 'eg',
  'south africa': 'za',
  'morocco': 'ma',
  'israel': 'il',
  'uae': 'ae',
  'united arab emirates': 'ae',
  'qatar': 'qa',
  'kuwait': 'kw',
  'saudi arabia': 'sa',
  'oman': 'om',
  'jordan': 'jo',
  'lebanon': 'lb',
};

/**
 * Converts a flag state name to ISO 3166-1 alpha-2 country code
 * @param flagState - The flag state name (e.g., "Bahamas", "Panama")
 * @returns The country code in lowercase (e.g., "bs", "pa") or null if not found
 */
export const getCountryCodeFromFlagState = (flagState: string): string | null => {
  if (!flagState) return null;
  
  const normalized = flagState.toLowerCase().trim();
  return flagStateToCountryCode[normalized] || null;
};

